/**
 * Notification firing log (ported from CC `NotificationsPage.tsx`).
 */
import { Badge, Group, Paper, Stack, Text, Title } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";

import { fleetApi } from "../../api/fleet";
import { useSSE } from "../../hooks/useSSE";

export function FleetNotificationsPage() {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["fleet", "notifications"],
    queryFn: () => fleetApi.notifications.list(),
    refetchInterval: 15_000,
  });

  useSSE({ "notification.fired": () => void refetch() });

  return (
    <>
      <Title order={2} mb="lg">Notifications</Title>
      {isLoading && <Text c="dimmed">Loading…</Text>}
      <Stack>
        {data?.map((n) => (
          <Paper key={n.id} p="sm" withBorder>
            <Group justify="space-between">
              <Stack gap={2}>
                <Text size="sm">{n.message}</Text>
                <Text size="xs" c="dimmed">
                  {new Date(n.sent_at).toLocaleString()} · agent: {n.agent_id ?? "—"}
                </Text>
                {n.error && <Text size="xs" c="red">{n.error}</Text>}
              </Stack>
              <Badge color={n.status === "sent" ? "green" : n.status === "failed" ? "red" : "gray"}>
                {n.status}
              </Badge>
            </Group>
          </Paper>
        ))}
        {!isLoading && !data?.length && <Text c="dimmed">No notifications yet.</Text>}
      </Stack>
    </>
  );
}
